export default {
    namespaced: true,
    state: {
        gameResults: JSON.parse(window.localStorage.getItem("stats.gameResults") || "[]")
    },
    actions: {
        addGameResult({ commit }, gameResult) {
            commit("addGameResult", gameResult);
        }
    },
    mutations: {
        addGameResult(state, gameResult) {
            state.gameResults = [...state.gameResults, gameResult];
            window.localStorage.setItem("stats.gameResults", JSON.stringify(state.gameResults));
        }
    }
};
